
import React                           from 'react';
import { Observe }                     from 'rewire-core';
import Button                          from '@material-ui/core/Button';
import Icon                            from '@material-ui/core/Icon';
import { ToolbarButtons }              from './RuleSettingsEditor';
import TimecardExporterRuleEditorModel from './TimecardExporterRuleEditorModel';
import mainPageModel                   from '../main-navigation/MainPageModel';
import timecardExportOutputEditorModel from './TimecardExportOutputEditorModel';

export const ToolbarRunRulesButton = (_model: {settings: TimecardExporterRuleEditorModel}) => {
  return (
    <Observe>{() => (
      <Button className='span1' color='primary' variant='contained' disabled={!timecardExportOutputEditorModel.visible || !mainPageModel.canEditTimecardExporterRules} onClick={() => timecardExportOutputEditorModel.open()}>
        <Icon className='edit'>{'edit'}</Icon>
        Define Output File Layout
      </Button>
    )}</Observe>
  );
};

export default ({settings}: {settings: TimecardExporterRuleEditorModel}) => {
  return (
    <ToolbarButtons settings={settings}>
      <ToolbarRunRulesButton settings={settings} />
    </ToolbarButtons>
  );
};
